import React from 'react';
import { 
  Title,
  Typography,
  Modal,
  List,
  ListItem,
  Icon,
} from '@npm-registry/eapteka-ui';

import iconDelivery from '../../../assets/images/bannerRecipe/icon-delivery.svg';
import iconQr from '../../../assets/images/bannerRecipe/icon-qr.svg';
import iconMarker from '../../../assets/images/bannerRecipe/icon-marker.svg';
import './BannerModal.scss';

const list = [
  {
    icon: iconDelivery, 
    text: <span>Проверим рецепты и&nbsp;откроем доставку для товаров из&nbsp;них</span>,
  },
  {
    icon: iconQr, 
    text: <span>При получении заказа покажите QR-код рецепта курьеру</span>,
  },
  {
    icon: iconMarker, 
    text: <span>Действует для клиентов с&nbsp;рецептами из&nbsp;Московской и&nbsp;Белгородской областей</span>,
  },
];

const BannerModal = ({
  isShow,
  handleClose,
}) => {
  return (
    <Modal
      className='BannerRecipeModal_Root'
      visible={isShow}
      onClose={handleClose}
    >
      <div className='BannerRecipeModal_Inner'>
        <span className='BannerRecipeModal_Close' onClick={handleClose}>
          <Icon name='close'/>
        </span>
        <div className='BannerRecipeModal_Header'>
          <Title className='BannerRecipeModal_Title' tag='h3'>Получайте лекарства по&nbsp;рецепту на&nbsp;дом</Title>
        </div>
        <Typography className='BannerRecipeModal_Description'>Если у&nbsp;вас есть электронный рецепт, вы&nbsp;можете заказать по&nbsp;нему доставку</Typography>
        <List className='BannerRecipeModal_List'>
          {list.map((item) => (
            <ListItem className='BannerRecipeModal_ListItem' key={item.icon} addonBefore={<img src={item.icon} alt={item.text} />}>{item.text}</ListItem>
          ))}
        </List>
        <Typography className='BannerRecipeModal_Note' variant='p3'>*Для Москвы добавьте рецептурные товары в&nbsp;корзину из&nbsp;приложения ЕМИАС.ИНФО</Typography>
      </div>
    </Modal>
  );
};

export default BannerModal;
